import { render, staticRenderFns } from "./CancellationPolicyCard.vue?vue&type=template&id=5762d156&scoped=true&"
import script from "./CancellationPolicyCard.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicyCard.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicyCard.vue?vue&type=style&index=0&id=5762d156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762d156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VHover,VRow})
